import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChalkboardUser,
  faChartPie,
  faSitemap,
  faSwatchbook,
  faFilePen
} from '@fortawesome/free-solid-svg-icons';

export const SidebarData = [
  {
    title: 'Home',
    path: '/dashboard',
    icon: <i className='fa-kit fa-house' style={{fontSize: '1.5em'}}></i>,
    class: 'nav-text'
  },
  {
    title: 'My Classes',
    path: '/classes',
    icon: <FontAwesomeIcon icon={faChalkboardUser} />,
    class: 'nav-text'
  },
  {
    title: 'Assignments & Activities',
    path: '/assignments',
    icon: <FontAwesomeIcon icon={faSwatchbook} />,
    class: 'nav-text'
  },
  {
    title: 'My Content',
    path: '/mycontent',
    icon: <i className='fa-kit fa-clipboard' style={{fontSize: '1.8em'}}></i>,
    class: 'nav-text'
  },
  {
    title: 'Reports',
    path: '/reports',
    icon: <FontAwesomeIcon icon={faChartPie} />,
    class: 'nav-text'
  },
  {
    title: 'Methodize',
    path: '/methodize',
    icon: <FontAwesomeIcon icon={faSitemap} />,
    class: 'nav-text'
  },
  {
    title: 'Rook Blueprint',
    path: '/rookBlueprint',
    icon: <FontAwesomeIcon icon={faFilePen} />,
    class: 'nav-text'
  }
];
